import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useFgts = () => {
    const [maxWithdraw, setMaxWithdraw] = useState(0);
    const navigate = useNavigate();
    const faqs = [
        {
            question: "O que é antecipação do Saque-Aniversário FGTS?",
            answer:
                "A antecipação do Saque-Aniversário permite que você receba antecipadamente os valores que seriam liberados anualmente pelo FGTS, através de um empréstimo com garantia no próprio saldo do fundo.",
        },
        {
            question: "Qual a taxa de juros ao antecipar o Saque-Aniversário?",
            answer:
                "A taxa de juros da antecipação do Saque-Aniversário é a partir de 1,29% ao mês. Custo efetivo total a partir de 1,39% ao mês e 18,24% ao ano. Condição válida para vendas realizadas diretamente pelo Banco Bmg.",
        },
        {
            question: "Em quanto tempo o dinheiro cai na conta?",
            answer:
                "Empréstimo FGTS é liberado em até 48 horas em dias úteis, condicionado à formalização e análise.",
        },
        {
            question: "Como eu sei qual valor está disponível para antecipar?",
            answer:
                "É possível consultar seu saldo do FGTS ligando para o número 0800 726 0207, ou baixando o aplicativo do FGTS.",
        },
        {
            question: "Como faço os pagamentos das parcelas da antecipação do Saque-Aniversário?",
            answer:
                "O pagamento das parcelas da sua Antecipação do Saque-Aniversário é feito anualmente, no mês do seu aniversário, de forma automática, mediante repasse feito pela Caixa Econômica Federal ao Banco Bmg, até a quitação do contrato.",
        },
        {
            question: "Quem pode fazer a antecipação do Saque-Aniversário?",
            answer:
                "Todo trabalhador brasileiro que possui contrato de trabalho formal, regido pela Consolidação das Leis do Trabalho (CLT) e, ainda, trabalhadores domésticos, rurais, temporários, intermitentes, avulsos, safreiros e atletas profissionais têm direito ao FGTS.",
        },
        {
            question: "Eu posso liquidar parcial ou totalmente a minha antecipação do Saque-Aniversário?",
            answer:
                "Sim, a qualquer momento você pode efetuar a liquidação total ou parcial do seu contrato com a redução proporcional dos juros e demais acréscimos, que será calculada com base na taxa de juros pactuada no Contrato do empréstimo FGTS. Para isso você deverá procurar nossa Central de atendimento e solicitar seu boleto.",
        },
        {
            question: "Quantas parcelas do Saque-Aniversário eu posso antecipar?",
            answer:
                "Aqui, no Bmg, você pode antecipar o valor de até 10 (dez) parcelas anuais do seu Saque-Aniversário, desde que haja saldo em sua conta FGTS.",
        },
        {
            question: "O que é preciso para aderir à antecipação do Saque-Aniversário?",
            answer:
                "Você precisa aderir à modalidade de Saque-Aniversário, no aplicativo FGTS e autorizar a realização da consulta do saldo e bloqueio do seu FGTS pelo Banco BMG.",
        },
    ];

    const getSubHeader = () => (<section style={{ zIndex: 5 }} className="hidden md:flex bg-[#462A71] w-full px-4 py-2 flex items-center justify-center gap-5 fixed">
        <a href="#AboutFgts" className="text-white hover:opacity-[0.7] text-sm">O que é antecipação FGTS</a>
        <a href="#AdvantagesFgts" className="text-white hover:opacity-[0.7] text-sm">Vantagens</a>
        <a href="#HowAnticipateFgts" className="text-white hover:opacity-[0.7] text-sm">Como antecipar</a>
        <a href="#WhoCanHireFgts" className="text-white hover:opacity-[0.7] text-sm">Quem pode contratar</a>
        <a href="#Faq" className="text-white hover:opacity-[0.7] text-sm">Ajuda</a>
    </section>)

    function calculateFgts(value) {
        let result = 0;

        if (value <= 500) {
            result = value * 0.5;
        } else if (value <= 1000) {
            result = (value * 0.4) + 50;
        } else if (value <= 5000) {
            result = (value * 0.3) + 150;
        } else if (value <= 10000) {
            result = (value * 0.2) + 650;
        } else if (value <= 15000) {
            result = (value * 0.15) + 1150;
        } else if (value <= 20000) {
            result = (value * 0.10) + 1900;
        } else {
            result = (value * 0.05) + 2900;
        }

        setMaxWithdraw(result);
    }

    const onGoToRegister = () => navigate('/register')
    const onGoTo = (route) => navigate(route)

    return {
        getSubHeader,
        faqs,
        calculateFgts,
        maxWithdraw,
        onGoToRegister,
        onGoTo
    }
}